module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/como.753f517ee8c249a8e99ba658c9f2673a.jpg";